import React, { useEffect, useState } from "react";
// Components
import { Header } from "../../components/Landing/Header/haeder.view";
import { Cards } from "./components/Cards/cards";
import { ModalVisualizarInversion } from "../Landing/components/ModalVisualizarInversion";
import { ModalAvisoInfo } from "../Landing/components/ModalAvisoInfo";
import { Footer } from "../../components/Landing/Footer";
import { Carousel } from "./components/Carousel/Carousel";
import { AlternadorVista } from "../../components/Generales/AlternadorVista";
import { CampoDeBusqueda } from "../../components/Generales/CampoDeBusqueda";
import {
  ANCHOS_TABLA_CONVOCATORIA,
  ANCHO_TABLA_CONVOCATORIA,
  columnaMiniatura,
} from "../../utils/tablaConvocatoriaHelper";
import { Button, Table, Empty, Select, Drawer } from "antd";
import { ArrowRightOutlined, SearchOutlined } from "@ant-design/icons";
import apiMaestras from "../../api/Maestras/api-maestras";
import './PeopleList.scss';
const heroImage = process.env.PUBLIC_URL + encodeURI("/assets/landing/heroConvoca.webp");
// Hook
import { useLanding } from "../../hooks/useLanding";
// style
import "./landing.style.scss";
import { coloresEstado } from "../../constants/common"

// Se renombra porque dentro del render hay un 'fechaCierre' local, el
// arreglo del filtro, que tapaba a esta funcion y la volvia no invocable.
import { fechaCierre as horaRealDeCierre } from '../../utils/horaCierre';


const blockquoteStyle = {
  background: '#FFF',
  border: '1px solid #e2e8f0',
  borderRadius: '12px',
  margin: '0 auto',
  padding: 0,
  boxShadow: '0 4px 14px rgba(0, 0, 0, 0.05)',
  display: 'block',
  width: '100%',
  maxWidth: '260px',
  minWidth: '210px',
};

const divStyle = {
  padding: '16px'
};

const linkStyle = {
  color: '#000',
  fontFamily: 'Arial, sans-serif',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '17px',
  textDecoration: 'none'
};

const divCarrusel = {
  backgroundColor: 'transparent',
  padding: '0',
  borderRadius: '0',
  boxShadow: 'none',
};

const normalizarTexto = (texto: any): string => {
  if (!texto || typeof texto !== "string") return "";
  return texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
};

export const Landing = () => {
  // state component
  const {
    principalState,
    getConvocatorias,
    setPrincipalState,
    buscarconvocatorias,
    buscarPorTexto,
    limipiarfiltros,
    loadingConvocatorias
  } = useLanding();

  React.useEffect(() => {
    getLineasConvocatorias();
  }, []);

  useEffect(() => {
    if ((window as any).instgrm) {
      (window as any).instgrm.Embeds?.process();
      return;
    }
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  // Se entra viendo la tabla: compara de un vistazo y cabe mas en pantalla.
  const [mostrarTabla, setMostrarTabla] = useState(true);
  const [textoBusqueda, setTextoBusqueda] = useState<string>("");
  const [filtroActivo, setFiltroActivo] = useState<string>("todas");
  const [expresionSeleccionada, setExpresionSeleccionada] = useState<string>("");
  const [drawerExpresionesOpen, setDrawerExpresionesOpen] = useState<boolean>(false);
  const [busquedaExpresionModal, setBusquedaExpresionModal] = useState<string>("");

  const convocatoriasValidas = (principalState.todaslasconvocatorias || []).filter(
    (data: any) => data.entidad !== "SM" && data.entidad !== "MCM" && data.entidad !== "PP" && data.entidad !== "AGENDA CULTURAL"
  );
  const totalConvocatorias = convocatoriasValidas.length;

  const obtenerEstadoCalculado = (convocatoria: any): string => {
    let estadoAct = convocatoria.estado || "Cerrada";
    if (Array.isArray(convocatoria.fechas)) {
      const fechaCierreObj = convocatoria.fechas.find((data: any) => data.clave === "Cierre");
      if (fechaCierreObj && fechaCierreObj.valormax) {
        const fechaActual = new Date();
        const anio = fechaActual.getFullYear();
        const mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2);
        const dia = ('0' + fechaActual.getDate()).slice(-2);
        const hora = ('0' + fechaActual.getHours()).slice(-2);
        const minutos = ('0' + fechaActual.getMinutes()).slice(-2);
        const fechaYHora = `${anio}-${mes}-${dia} ${hora}:${minutos}`;

        const cierreAct = horaRealDeCierre(fechaCierreObj.valormax);
        const anioc = cierreAct.getFullYear();
        const mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
        const diac = ('0' + cierreAct.getDate()).slice(-2);
        const horac = ('0' + cierreAct.getHours()).slice(-2);
        const minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
        const fechaYHoraActualizada = `${anioc}-${mesc}-${diac} ${horac}:${minutosc}`;

        if (fechaYHoraActualizada <= fechaYHora) {
          estadoAct = 'Cerrada';
        }
      }
    }
    return estadoAct;
  };

  const abiertasCount = convocatoriasValidas.filter((data: any) => obtenerEstadoCalculado(data) === "Abierta").length;

  // Extracción dinámica de todas las expresiones disponibles con convocatorias
  const expresionesDisponibles = React.useMemo(() => {
    const mapa = new Map<string, number>();
    const lista = (convocatoriasValidas && convocatoriasValidas.length > 0)
      ? convocatoriasValidas
      : (principalState.todaslasconvocatorias || []);

    lista.forEach((c: any) => {
      const areas = Array.isArray(c?.area)
        ? c.area
        : Array.isArray(c?.areas)
        ? c.areas
        : Array.isArray(c?.areas_convocatorias)
        ? c.areas_convocatorias
        : [];

      if (areas.length > 0) {
        areas.forEach((a: any) => {
          const rawNombre = typeof a === "string" ? a : (a?.text || a?.nombre || "");
          const nombre = rawNombre.trim();
          const nomNorm = normalizarTexto(nombre);
          if (
            nombre &&
            !nomNorm.includes("estimulo") &&
            !nomNorm.includes("fomento")
          ) {
            mapa.set(nombre, (mapa.get(nombre) || 0) + 1);
          }
        });
      }
    });

    return Array.from(mapa.entries())
      .map(([nombre, count]) => ({ nombre, count }))
      .sort((a, b) => a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base" }));
  }, [convocatoriasValidas, principalState.todaslasconvocatorias]);

  // Expresiones filtradas dentro del drawer móvil según lo que escriba el usuario
  const expresionesFiltradasDrawer = React.useMemo(() => {
    if (!busquedaExpresionModal.trim()) return expresionesDisponibles;
    const q = normalizarTexto(busquedaExpresionModal);
    return expresionesDisponibles.filter((e) => normalizarTexto(e.nombre).includes(q));
  }, [expresionesDisponibles, busquedaExpresionModal]);

  const getLineasConvocatorias = async () => {
    try {
      const data = await apiMaestras.obtenerLineaConvocatoria();
      setLineasConvocatorias(Array.isArray(data) ? data : (data?.data || []));
    } catch (error) {
      console.warn("No se pudieron cargar las líneas de convocatoria en Landing; se continúa con valores por defecto:", error);
      setLineasConvocatorias([]);
    }
  };

  const getFilterLineaConvocatoria = (idLineaConvocatoria: any, data: any) => {
    const valueFilter = LineasConvocatorias.filter(
      (x: any) => String(x.id) === String(idLineaConvocatoria)
    );
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    } else {
      const nom = normalizarTexto(data?.nombre_convocatoria);
      if (nom.includes("jurado")) {
        return "Banco de Jurados";
      } else {
        return "Estímulos y Fomento";
      }
    }
  };

  // Verifica si una convocatoria pertenece a Banco de Jurados por línea o por nombre
  const esConvocatoriaJurados = (c: any): boolean => {
    if (!c) return false;

    // 1. Nombre de la convocatoria
    const nomConv = normalizarTexto(c.nombre_convocatoria);
    if (nomConv.includes("jurado")) return true;

    // 2. Nombre de la línea en el maestro de LineasConvocatorias
    if (Array.isArray(LineasConvocatorias) && LineasConvocatorias.length > 0) {
      const lineaObj = LineasConvocatorias.find(
        (l: any) => String(l?.id) === String(c?.linea_convocatoria)
      );
      if (lineaObj?.nombre) {
        const nomLineaMaestro = normalizarTexto(lineaObj.nombre);
        if (nomLineaMaestro.includes("jurado")) return true;
      }
    }

    // 3. Propiedades directas de línea en el objeto convocatoria
    const nomLineaDirecto = normalizarTexto(
      (typeof c.nombre_linea === "string" ? c.nombre_linea : "") ||
      (typeof c.linea_nombre === "string" ? c.linea_nombre : "") ||
      (typeof c.lineas_convocatoria === "string" ? c.lineas_convocatoria : "") ||
      (typeof c.linea === "string" ? c.linea : "") ||
      (typeof c.linea_convocatoria === "string" && isNaN(Number(c.linea_convocatoria)) ? c.linea_convocatoria : "")
    );
    if (nomLineaDirecto.includes("jurado")) return true;

    // 4. Nombre devuelto por getFilterLineaConvocatoria
    const lineaCalculada = normalizarTexto(getFilterLineaConvocatoria(c.linea_convocatoria, c));
    if (lineaCalculada.includes("jurado")) return true;

    // 5. Preservar compatibilidad con el ID histórico conocido
    if (String(c.linea_convocatoria) === "72") return true;

    return false;
  };

  const FILTROS_RAPIDOS = [
    { id: "todas", label: "✨ Todas" },
    { id: "abiertas", label: "🟢 Abiertas Ahora" },
    { id: "jurados", label: "👥 Banco de Jurados" },
  ];

  const juradosCount = React.useMemo(() => {
    return convocatoriasValidas.filter((c: any) => esConvocatoriaJurados(c)).length;
  }, [convocatoriasValidas, LineasConvocatorias]);

  const toggleFiltroJurados = () => {
    if (filtroActivo === "jurados") {
      setFiltroActivo("todas");
    } else {
      setFiltroActivo("jurados");
      setExpresionSeleccionada("");
      setTextoBusqueda("");
      buscarPorTexto("");
    }
  };

  const handleFiltroChip = (filtro: { id: string; label: string }) => {
    // Si vuelven a presionar un filtro ya activo (como jurados), se desactiva y vuelve a 'todas'
    if (filtro.id === filtroActivo && filtro.id !== "todas") {
      setFiltroActivo("todas");
      setExpresionSeleccionada("");
      setTextoBusqueda("");
      buscarPorTexto("");
      return;
    }

    setFiltroActivo(filtro.id);
    setExpresionSeleccionada("");
    setTextoBusqueda("");
    buscarPorTexto("");

    const el = document.getElementById("seccion-busqueda") || document.getElementById("convocatorias");
    el?.scrollIntoView({ behavior: "smooth" });
  };

  const handleExpresionChip = (expNombre: string) => {
    if (expresionSeleccionada.toLowerCase() === expNombre.toLowerCase()) {
      setExpresionSeleccionada("");
    } else {
      setExpresionSeleccionada(expNombre);
      setFiltroActivo("todas");
      setTextoBusqueda("");
      buscarPorTexto("");
    }
    const el = document.getElementById("seccion-busqueda") || document.getElementById("convocatorias");
    el?.scrollIntoView({ behavior: "smooth" });
  };

  const handleExpresionSelect = (val: string) => {
    const nuevaExp = val === "todas" ? "" : val;
    setExpresionSeleccionada(nuevaExp);
    setFiltroActivo("todas");
    setTextoBusqueda("");
    buscarPorTexto("");
  };

  const handleBusquedaTexto = (txt: string) => {
    setTextoBusqueda(txt);
    buscarPorTexto(txt);
    if (txt && txt.trim() !== "") {
      setExpresionSeleccionada("");
      setFiltroActivo("todas");
    }
  };

  const convocatoriasFiltradas = React.useMemo(() => {
    let resultado = convocatoriasValidas;

    // Los filtros funcionan individualmente (mutuamente exclusivos):
    // 1. Si hay texto en el buscador, filtra únicamente por texto
    if (textoBusqueda && textoBusqueda.trim() !== "") {
      const q = normalizarTexto(textoBusqueda);
      resultado = resultado.filter((c: any) => {
        const nom = normalizarTexto(c.nombre_convocatoria);
        const ent = normalizarTexto(c.entidad);
        const lin = normalizarTexto(getFilterLineaConvocatoria(c.linea_convocatoria, c));
        const areas = Array.isArray(c.area)
          ? c.area.map((a: any) => normalizarTexto(a?.text || a?.nombre)).join(" ")
          : "";
        return nom.includes(q) || ent.includes(q) || lin.includes(q) || areas.includes(q);
      });
    }
    // 2. Si hay expresión artística seleccionada, filtra únicamente por expresión
    else if (expresionSeleccionada && expresionSeleccionada !== "todas") {
      const expBuscada = normalizarTexto(expresionSeleccionada);
      resultado = resultado.filter((c: any) => {
        const areas = Array.isArray(c?.area)
          ? c.area
          : Array.isArray(c?.areas)
          ? c.areas
          : Array.isArray(c?.areas_convocatorias)
          ? c.areas_convocatorias
          : [];
        return areas.some((a: any) => {
          const raw = typeof a === "string" ? a : (a?.text || a?.nombre || "");
          return normalizarTexto(raw) === expBuscada;
        });
      });
    }
    // 3. Filtro rápido de estado o tipo (abiertas o jurados)
    else if (filtroActivo === "abiertas") {
      resultado = resultado.filter((c: any) => obtenerEstadoCalculado(c) === "Abierta");
    } else if (filtroActivo === "jurados") {
      resultado = resultado.filter((c: any) => esConvocatoriaJurados(c));
    }

    return resultado.sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias);
  }, [convocatoriasValidas, filtroActivo, expresionSeleccionada, textoBusqueda, LineasConvocatorias]);

  const datosTabla = convocatoriasFiltradas.map((data: any) => ({
    // Mapear aquí los datos que quieres mostrar en la tabla
    idconvocatorias: data.idconvocatorias,
    nombre_convocatoria: data.nombre_convocatoria,
    portada_url: data.portada_url,
    fechas: data.fechas,
    estado: data.estado,
    entidad: data.entidad,
    linea_convocatoria: data.linea_convocatoria,
    tipo_participante: data.tipo_participante,
    area: data.area
  }));

  const columns = [
    columnaMiniatura(),
    {
      title: "Nombre convocatoria",
      width: ANCHOS_TABLA_CONVOCATORIA.nombre,
      dataIndex: "nombre_convocatoria",
      key: "nombre_convocatoria",
      render: (datos) => {
        return (
          <span style={{ whiteSpace: "pre-line" }}>
            {datos}
          </span>
        );
      },
    },
    {
      title: "Línea convocatoria",
      width: ANCHOS_TABLA_CONVOCATORIA.linea,
      render: (datos) => {
        return (
          <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line", fontWeight: "bold" }}>
            {getFilterLineaConvocatoria(datos?.linea_convocatoria, datos) !== undefined ? `${getFilterLineaConvocatoria(datos?.linea_convocatoria, datos)}` : ""}
          </span>
        );
      },
    },
    {
      title: "Fecha apertura",
      width: ANCHOS_TABLA_CONVOCATORIA.apertura,
      render: (datos) => {
        let fecha = datos.fechas;
        let estadoAct: any;
        if (Array.isArray(datos.fechas)) {
          let fechaapertura = datos.fechas.filter(
            (data) => data.clave === "Apertura"
          );
          if (fechaapertura.length > 0) {
            fecha = fechaapertura[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Fecha cierre",
      width: ANCHOS_TABLA_CONVOCATORIA.cierre,
      render: (datos) => {
        let fecha = datos.fechas;
        let estadoAct: any;
        if (Array.isArray(datos.fechas)) {
          let fechacierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );
          if (fechacierre.length > 0) {
            fecha = fechacierre[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Tipo participante",
      width: ANCHOS_TABLA_CONVOCATORIA.participante,
      render: (datos) => {
        // Unidos, no con un separador colgando al final de cada uno.
        const tipo_participante = Array.isArray(datos.tipo_participante)
          ? datos.tipo_participante.map((tipo: any) => tipo.text).join(" - ")
          : "";
        return <span className="font-family-Montserrat-Regular">{tipo_participante}</span>;
      }
    },
    {
      title: "Estado",
      width: ANCHOS_TABLA_CONVOCATORIA.estado,
      render: (datos) => {
        let fecha = datos.fechas;
        // Sin fecha de cierre que mirar, el estado es el que ya trae.
        let estadoAct: any = datos.estado;
        if (Array.isArray(datos.fechas)) {
          let fechaCierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );

          if (fechaCierre.length > 0) {
            fecha = fechaCierre[0].valormax

            let fechaActual = new Date();
            let anio = fechaActual.getFullYear();
            let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2)
            let dia = ('0' + fechaActual.getDate()).slice(-2);
            let hora = ('0' + fechaActual.getHours()).slice(-2);
            let minutos = ('0' + fechaActual.getMinutes()).slice(-2);

            let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

            let cierreAct = horaRealDeCierre(fecha);
            let anioc = cierreAct.getFullYear();
            let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
            let diac = ('0' + cierreAct.getDate()).slice(-2);
            let horac = ('0' + cierreAct.getHours()).slice(-2);
            let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
            let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

            if (fechaYHoraActualizada <= fechaYHora) {
              estadoAct = 'Cerrada';
            }
          }
        }
        return (<span style={{ color: coloresEstado[estadoAct], marginLeft: "0" }}>
          {estadoAct}
        </span>)
      },
    },
    {
      title: "Entidad",
      width: ANCHOS_TABLA_CONVOCATORIA.entidad,
      dataIndex: "entidad",
      key: "entidad",
    },
    {
      title: "Expresiones",
      width: ANCHOS_TABLA_CONVOCATORIA.area,
      render: (datos) => {
        if (Array.isArray(datos.area)) {
          let area = "";
          datos.area.forEach((tipo, index) => {
            area += tipo.text;
            if (index < datos.area.length - 1) {
              area += ", ";
            } else {
              area += ".";
            }
          });
          return <span className="font-family-Montserrat-Regular" style={{ whiteSpace: "pre-line" }}>{area}</span>;
        }
        return null;
      }
    }
  ];

  const handleRowClick = (record: any) => {
    window.open(`/estimuloscultura/verconvocatoria/${record.idconvocatorias}`, "_blank", "noopener,noreferrer")
  };
  // component mounted
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, []);
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);


  const [visualizarAviso, setVisualizarAviso] = useState<boolean>(false);
  const [avisoInfo, setAvisoInfo] = useState<boolean>(false);








  useEffect(() => {
    const handleResize = () => {
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Header />

      {/* Hero Convocatorias Modern 21st.dev Style */}
      <section
        className="hero-convoca-container"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="hero-convoca-overlay">
          <div className="hero-convoca-content">
            {/* Pastilla Shimmer superior */}
            <div className="hero-badge-pill">
              <span className="hero-badge-pulse" />
              <span>Portal de Fomento y Estímulos Culturales · Alcaldía de Medellín</span>
            </div>

            {/* Título Principal Compacto y Elegante */}
            <h1 className="hero-convoca-title">
              Convocatorias de <span className="hero-gradient-text">Fomento y Estímulos</span>
            </h1>

            {/* Subtítulo */}
            <p className="hero-convoca-subtitle">
              Oportunidades, apoyos económicos y jurados para artistas y gestores culturales de Medellín.
            </p>

            {/* Caja de Búsqueda Flotante en Hero */}
            <div className="hero-quick-search-box">
              <div className="hero-search-input-wrapper">
                <SearchOutlined className="hero-search-icon" />
                <input
                  type="text"
                  className="hero-search-input"
                  placeholder="Busca por nombre, área artística, expresión o palabra clave..."
                  value={textoBusqueda}
                  onChange={(e) => {
                    handleBusquedaTexto(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const el = document.getElementById("convocatorias");
                      el?.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                />
                {textoBusqueda && (
                  <button
                    type="button"
                    className="hero-search-clear"
                    onClick={() => {
                      handleBusquedaTexto("");
                    }}
                    aria-label="Limpiar búsqueda"
                  >
                    ✕
                  </button>
                )}
                <button
                  type="button"
                  className="hero-search-btn"
                  onClick={() => {
                    const el = document.getElementById("convocatorias");
                    el?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Explorar
                </button>
              </div>

              {/* Pastillas en Desktop: Todas en varias líneas centradas */}
              <div className="hero-quick-filter-chips d-none d-md-flex">
                {FILTROS_RAPIDOS.map((filtro) => (
                  <button
                    key={filtro.id}
                    type="button"
                    className={`filter-chip-btn ${filtroActivo === filtro.id && !expresionSeleccionada ? "active" : ""}`}
                    onClick={() => handleFiltroChip(filtro)}
                  >
                    {filtro.label}
                  </button>
                ))}
                {expresionesDisponibles.map((exp) => (
                  <button
                    key={exp.nombre}
                    type="button"
                    className={`filter-chip-btn ${expresionSeleccionada.toLowerCase() === exp.nombre.toLowerCase() ? "active" : ""}`}
                    onClick={() => handleExpresionChip(exp.nombre)}
                  >
                    {exp.nombre}
                  </button>
                ))}
              </div>

              {/* Presentación Optimizada en Mobile: Swipeable + Bottom Sheet Drawer */}
              <div className="hero-mobile-expresiones-bar d-flex d-md-none">
                <div className="mobile-quick-chips">
                  {FILTROS_RAPIDOS.map((filtro) => (
                    <button
                      key={filtro.id}
                      type="button"
                      className={`filter-chip-btn ${filtroActivo === filtro.id && !expresionSeleccionada ? "active" : ""}`}
                      onClick={() => handleFiltroChip(filtro)}
                    >
                      {filtro.label}
                    </button>
                  ))}
                  {expresionSeleccionada && (
                    <button
                      type="button"
                      className="filter-chip-btn active chip-expresion-activa"
                      onClick={() => {
                        setExpresionSeleccionada("");
                        setFiltroActivo("todas");
                        setTextoBusqueda("");
                        buscarPorTexto("");
                      }}
                      title="Quitar filtro de expresión"
                    >
                      <span>{expresionSeleccionada}</span>
                      <span className="chip-remove-icon">✕</span>
                    </button>
                  )}
                </div>

                <div className="mobile-expresiones-carousel">
                  <div className="mobile-carousel-track">
                    <button
                      type="button"
                      className="filter-chip-btn chip-open-drawer"
                      onClick={() => setDrawerExpresionesOpen(true)}
                    >
                      <span>✦ Ver todas las expresiones ({expresionesDisponibles.length})</span>
                    </button>
                    {expresionesDisponibles.map((exp) => (
                      <button
                        key={exp.nombre}
                        type="button"
                        className={`filter-chip-btn ${expresionSeleccionada.toLowerCase() === exp.nombre.toLowerCase() ? "active" : ""}`}
                        onClick={() => handleExpresionChip(exp.nombre)}
                      >
                        {exp.nombre}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Botones de acción CTA */}
            <div className="hero-convoca-actions">
              <button
                type="button"
                className="hero-btn-primary"
                onClick={() => {
                  setFiltroActivo("todas");
                  setExpresionSeleccionada("");
                  setTextoBusqueda("");
                  const el = document.getElementById("seccion-busqueda") || document.getElementById("convocatorias");
                  el?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                <span>Ver todas las convocatorias ({totalConvocatorias})</span>
                <ArrowRightOutlined />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Drawer Bottom Sheet Móvil para Expresiones Artísticas */}
      <Drawer
        title={null}
        placement="bottom"
        height="74vh"
        closable={false}
        onClose={() => setDrawerExpresionesOpen(false)}
        visible={drawerExpresionesOpen}
        open={drawerExpresionesOpen}
        className="mobile-expresiones-drawer"
      >
        <div className="mobile-drawer-inner-content">
          <div className="drawer-handle-bar" />
          <div className="drawer-header-row">
            <div>
              <h3 className="drawer-title">Expresiones Artísticas</h3>
              <p className="drawer-subtitle">{expresionesDisponibles.length} expresiones con convocatorias vigentes</p>
            </div>
            <button
              type="button"
              className="drawer-close-btn"
              onClick={() => setDrawerExpresionesOpen(false)}
              aria-label="Cerrar"
            >
              ✕
            </button>
          </div>

          <div className="drawer-search-wrapper">
            <SearchOutlined className="drawer-search-icon" />
            <input
              type="text"
              className="drawer-search-input"
              placeholder="Buscar expresión artística..."
              value={busquedaExpresionModal}
              onChange={(e) => setBusquedaExpresionModal(e.target.value)}
            />
            {busquedaExpresionModal && (
              <button
                type="button"
                className="drawer-search-clear"
                onClick={() => setBusquedaExpresionModal("")}
              >
                ✕
              </button>
            )}
          </div>

          <div className="drawer-all-option">
            <button
              type="button"
              className={`drawer-option-pill ${!expresionSeleccionada ? "active" : ""}`}
              onClick={() => {
                setExpresionSeleccionada("");
                setFiltroActivo("todas");
                setTextoBusqueda("");
                buscarPorTexto("");
                setDrawerExpresionesOpen(false);
                const el = document.getElementById("seccion-busqueda") || document.getElementById("convocatorias");
                el?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              <span>Todas las expresiones</span>
              <span className="drawer-option-count">{totalConvocatorias}</span>
            </button>
          </div>

          <div className="drawer-expresiones-grid">
            {expresionesFiltradasDrawer.map((exp) => {
              const isActive = expresionSeleccionada.toLowerCase() === exp.nombre.toLowerCase();
              return (
                <button
                  key={exp.nombre}
                  type="button"
                  className={`drawer-option-pill ${isActive ? "active" : ""}`}
                  onClick={() => {
                    handleExpresionChip(exp.nombre);
                    setDrawerExpresionesOpen(false);
                    const el = document.getElementById("seccion-busqueda") || document.getElementById("convocatorias");
                    el?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <span className="drawer-option-name">{exp.nombre}</span>
                  <span className="drawer-option-count">{exp.count}</span>
                </button>
              );
            })}
          </div>
        </div>
      </Drawer>

      <div id="seccion-busqueda" className="container-fluid2">
        {/* Dock Flotante de Control */}
        <div className="convocatorias-filter-dock">
          <div className="row g-2 align-items-center">
            <div className="col-12 col-md-auto">
              <AlternadorVista mostrarTabla={mostrarTabla} alCambiar={setMostrarTabla} />
            </div>
            <div className="col-12 col-md-auto dock-select-col">
              <Select
                className="expresiones-select-dock"
                size="large"
                value={expresionSeleccionada || "todas"}
                onChange={handleExpresionSelect}
                dropdownMatchSelectWidth={false}
              >
                <Select.Option value="todas">Todas las expresiones ({totalConvocatorias})</Select.Option>
                {expresionesDisponibles.map((exp) => (
                  <Select.Option key={exp.nombre} value={exp.nombre}>
                    {exp.nombre} ({exp.count})
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className="col-12 col-md-auto dock-jurados-col">
              <button
                type="button"
                className={`dock-jurados-btn ${filtroActivo === "jurados" ? "active" : ""}`}
                onClick={toggleFiltroJurados}
                title={filtroActivo === "jurados" ? "Quitar filtro de Banco de Jurados" : "Filtrar por Banco de Jurados"}
              >
                <span className="dock-jurados-label">👥 Banco de Jurados</span>
                {filtroActivo === "jurados" ? (
                  <span className="dock-jurados-close" aria-label="Quitar">✕</span>
                ) : (
                  <span className="dock-jurados-badge">{juradosCount}</span>
                )}
              </button>
            </div>
            <div className="col-12 col-md">
              <CampoDeBusqueda
                textoInicial={textoBusqueda}
                alBuscar={handleBusquedaTexto}
              />
            </div>
          </div>
        </div>
      </div>

      <div id="convocatorias"></div>
      {mostrarTabla ? (
        <div className="container-fluid2">
          <div className="modern-table-container">
            <Table
              rowKey="idconvocatorias"
              style={{ fontSize: '15px' }}
              locale={{ emptyText: <Empty description="No se encontraron convocatorias para este filtro" style={{ padding: "50px" }} /> }}
              pagination={{
                defaultPageSize: 10,
                pageSizeOptions: ["10", "20", "50"],
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} convocatorias`,
                className: "modern-custom-pagination",
              }}
              scroll={{ x: ANCHO_TABLA_CONVOCATORIA }}
              columns={columns}
              dataSource={datosTabla}
              size="middle"
              bordered={false}
              loading={loadingConvocatorias}
              onRow={(record) => {
                return {
                  onClick: () => handleRowClick(record),
                  style: {
                    cursor: 'pointer',
                  },
                }
              }}
            />
          </div>
        </div>
      ) : (
        <div className="container-fluid2">
          {datosTabla.length === 0 && !loadingConvocatorias ? (
            <div className="modern-table-container text-center py-5">
              <Empty description="No se encontraron convocatorias para este filtro" style={{ padding: "40px" }} />
            </div>
          ) : (
            <div className="row g-4">
              {convocatoriasFiltradas.map((data: any) => (
                <div key={`contenedor_${data.idconvocatorias}`} className="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex">
                  <Cards key={data.idconvocatorias} convocatorias={data} />
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/*visibleButton &&
        <Buttonloadmore doFunction={() => getSiguientesConvocatorias()}/>
      */}
      <br />
      <br />
      <div className="container-fluid2">
        <div>
          <div className="row text-center">
            <span className="pb-3 font-size-30px font-family-Montserrat-SemiBold">
              Conoce nuestra{" "}
              <span className="font-family-Montserrat-Bold">
                gestión
              </span>
            </span>
          </div>
          <hr />
          <div className="instagram-section-container">
            <div className="instagram-posts-track">
              <div className="instagram-post-item">
                <div className="instagram-card-wrapper">
                  <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/p/DU4N1XnDooF/?img_index=1"
                    data-instgrm-version="12"
                    style={blockquoteStyle}
                  >
                    <div style={divStyle}>
                      <a
                        href="https://www.instagram.com/p/DU4N1XnDooF/?img_index=1"
                        style={linkStyle}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ver esta publicación en Instagram
                      </a>
                    </div>
                  </blockquote>
                </div>
              </div>
              <div className="instagram-post-item">
                <div className="instagram-card-wrapper">
                  <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/p/DU8ZnclDjMa/"
                    data-instgrm-version="12"
                    style={blockquoteStyle}
                  >
                    <div style={divStyle}>
                      <a
                        href="https://www.instagram.com/p/DU8ZnclDjMa/"
                        style={linkStyle}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ver esta publicación en Instagram
                      </a>
                    </div>
                  </blockquote>
                </div>
              </div>
              <div className="instagram-post-item">
                <div className="instagram-card-wrapper">
                  <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/p/DU50xF4Di4u/"
                    data-instgrm-version="12"
                    style={blockquoteStyle}
                  >
                    <div style={divStyle}>
                      <a
                        href="https://www.instagram.com/p/DU50xF4Di4u/"
                        style={linkStyle}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ver esta publicación en Instagram
                      </a>
                    </div>
                  </blockquote>
                </div>
              </div>
              <div className="instagram-post-item">
                <div className="instagram-card-wrapper">
                  <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/p/DU0rN76Dm-p/"
                    data-instgrm-version="12"
                    style={blockquoteStyle}
                  >
                    <div style={divStyle}>
                      <a
                        href="https://www.instagram.com/p/DU0rN76Dm-p/"
                        style={linkStyle}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ver esta publicación en Instagram
                      </a>
                    </div>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
      <div className="container-fluid2">
        <div>
          <div className="row text-center">
            <span className="pb-3 font-size-30px font-family-Montserrat-SemiBold">
              Conoce cómo inscribirte{" "}
              <span className="font-family-Montserrat-Bold">
                y quiénes lo han logrado
              </span>
            </span>
          </div>
          <hr />
          <div className="row">
            <div className="col-12 col-md-6 col-sm-6">
              <br />
              <div className="font-size-16px font-family-Montserrat-Bold text-center font-color-black">
                Tutorial de cómo gestionar y recuperar la clave:
              </div>
              <br />
              <iframe src="https://www.youtube.com/embed/Lo5VZP6jYnA?si=wP0B9Mt6YoYCOD0c"
                title="YouTube video player"
                style={{ width: '100%', height: '400px' }}
              >
              </iframe>
            </div>
            <div className="col-12 col-md-6 col-sm-6">
              <br />
              <div className="font-size-16px font-family-Montserrat-Bold text-center font-color-black">
                Tutorial de cómo inscribir un proyecto:
              </div>
              <br />
              <iframe src="https://www.youtube.com/embed/iGWt5sqV7iI?si=BSx-dFla1y941BIh"
                title="YouTube video player"
                style={{ width: '100%', height: '400px' }}
              >
              </iframe>
            </div>
          </div>
          <br />
          <br />
          <div className="row text-center">
            <span className="pb-3 font-size-30px font-family-Montserrat-SemiBold">
              ABECÉ Convocatorias de{" "}
              <span className="font-family-Montserrat-Bold">
                Fomento y Estímulos para el Arte y la Cultura
              </span>
            </span>
          </div>
          <hr />
          <div className="row flex flex-row justify-center items-center" style={{ textAlign: 'justify' }}>
            <div>
              <Carousel></Carousel>
            </div>
            <br />
            <br />
            <div className="row" style={{ textAlign: 'justify', marginTop: '5' }}>
            </div>
            <br />
            <div className="row text-center">
              {/*<span id="mapContainer" className="pb-3 font-size-20px font-family-Montserrat-SemiBold">
                Mueve el cursor por el mapa para conocer la inversión por comuna en el año 2024
              </span>*/}
            </div>
            {/*
            <div className="row text-center" id="mapContainer">
              <span className="pb-3 font-size-30px font-family-Montserrat-Semi  Bold">
                ¡Gracias a las convocatorias lo hacemos posible!
              </span>
              <br />
              <img src={mapaCifras} style={{maxWidth: '100%'}} alt="Inversion comunas"></img>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="map-container" id="mapContainer" style={{ width: '1100px', margin: '0 auto'}}>
              <Space wrap>
                <Popover content={content("comuna90")} title="Comuna 90 (Santa Elena)" trigger="hover" placement="right">
                  <img src={Comuna90} className="region" alt="comuna 90" style={{top: '-10%', right: '2%', width: '40%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna1")} title="Comuna 1 (Popular)" trigger="hover" placement="right">
                  <img src={Comuna1} className="region" alt="comuna 1" style={{top: '-12%', right: '30%', width: '9%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna2")} title="Comuna 2 (Santa Cruz)" trigger="hover" placement="right">
                  <img src={Comuna2} className="region" alt="comuna 2" style={{top: '-18%', right: '33%', width: '9%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna5")} title="Comuna 5 (Castilla)" trigger="hover" placement="right">
                  <img src={Comuna5} className="region" alt="comuna 5" style={{top: '-21%', right: '41%', width: '11%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna6")} title="Comuna 6 (Doce de Octubre)" trigger="hover" placement="right">
                  <img src={Comuna6} className="region" alt="comuna 6" style={{top: '-22%', right: '46%', width: '10%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna60")} title="Comuna 60 (San Critóbal)" trigger="hover" placement="right">
                  <img src={Comuna60} className="region" alt="comuna 60" style={{top: '-33%', right: '53%', width: '40%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna50")} title="Comuna 50 (San Sebastián de Palmitas)" trigger="hover" placement="right">
                  <img src={Comuna50} className="region" alt="comuna 50" style={{top: '-36%', left: '0%', width: '17%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna3")} title="Comuna 3 (Manrique)" trigger="hover" placement="right">
                  <img src={Comuna3} className="region" alt="comuna 3" style={{top: '2%', right: '28%', width: '11%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna4")} title="Comuna 4 (Aranjuez)" trigger="hover" placement="right">
                  <img src={Comuna4} className="region" alt="comuna 4" style={{top: '-2%', right: '37%', width: '9%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna7")} title="Comuna 7 (Robledo)" trigger="hover" placement="right">
                  <img src={Comuna7} className="region" alt="comuna 7" style={{top: '-6%', right: '48%', width: '21%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna8")} title="Comuna 8 (Villa Hermosa)" trigger="hover" placement="right">
                  <img src={Comuna8} className="region" alt="comuna 8" style={{top: '22%', right: '25%', width: '16%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna9")} title="Comuna 9 (Buenos Aires)" trigger="hover" placement="right">
                  <img src={Comuna9} className="region" alt="comuna 9" style={{top: '34%', right: '24%', width: '20%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna10")} title="Comuna 10 (La Candelaria)" trigger="hover" placement="right">
                  <img src={Comuna10} className="region" alt="comuna 10" style={{top: '20%', right: '38%', width: '11%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna11")} title="Comuna 11 (Laureles Estadio)" trigger="hover" placement="right">
                  <img src={Comuna11} className="region" alt="comuna 11" style={{top: '14%', right: '50%', width: '15%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna12")} title="Comuna 12 (La América)" trigger="hover" placement="right">
                  <img src={Comuna12} className="region" alt="comuna 12" style={{top: '12%', right: '57%', width: '10%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna13")} title="Comuna 13 (San Javier)" trigger="hover" placement="right">
                  <img src={Comuna13} className="region" alt="comuna 13" style={{top: '10%', left: '28%', width: '14%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna14")} title="Comuna 14 (El Poblado)" trigger="hover" placement="right">
                  <img src={Comuna14} className="region" alt="comuna 14" style={{top: '46%', right: '34%', width: '16%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna15")} title="Comuna 15 (Guayabal)" trigger="hover" placement="right">
                  <img src={Comuna15} className="region" alt="comuna 15" style={{top: '39%', right: '50%', width: '11%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna16")} title="Comuna 16 (Belén)" trigger="hover" placement="right">
                  <img src={Comuna16} className="region" alt="comuna 16" style={{top: '34%', right: '50%', width: '19%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna70")} title="Comuna 70 (Altavista)" trigger="hover" placement="right">
                  <img src={Comuna70} className="region" alt="comuna 70" style={{top: '19%', right: '58%', width: '28%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <Popover content={content("comuna80")} title="Comuna 80 (San Antonio de Prado)" trigger="hover" placement="right">
                  <img src={Comuna80} className="region" alt="comuna 80" style={{top: '9%', left: '2%', width: '21%', pointerEvents: 'visiblePainted'}}></img>
                </Popover>
                <img src={Rio} className="rio" alt="rio de medellin" style={{top: '-20%', left: '47%', width: '14%'}}></img>
              </Space>
              <br />
              <br />
            </div>
            <div id="mapContainer" className="row text-center" style={{display: 'flex', justifyContent: 'center'}}>
              <Button className="button-azul-radius font-family-Montserrat-SemiBold" style={{width: 'auto'}} onClick={openModal}>
                Inversión por áreas
              </Button>
            </div>
            */}

          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="row">
        {"  "}
      </div>
      <ModalVisualizarInversion
        visualizar={visualizarAviso}
        setVisualizar={setVisualizarAviso}
      />
      <ModalAvisoInfo
        visualizar={avisoInfo}
        setVisualizar={setAvisoInfo}
      />
      <br />
      <Footer />
    </div>
  );
};
